import { render, staticRenderFns } from "./SalaryFilter.vue?vue&type=template&id=ec9f4044&"
import script from "./SalaryFilter.vue?vue&type=script&lang=js&"
export * from "./SalaryFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports